// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__zlrzr","inner":"Form_inner__3HTvn","range":"Form_range__s5ayL","name":"Form_name__2mQ9B","actions":"Form_actions__1vGKc"};